module.exports = __webpack_public_path__ + "img/price-square-meter-5.97a6b7c9.jpg";